export class EmployeeDoctorModel {
    employee_no: number
    employee_initial: string
    employee_name: string

    constructor(
        employee_no: number,
        employee_initial: string,
        employee_name: string
    ) {
        this.employee_no = employee_no
        this.employee_initial = employee_initial
        this.employee_name = employee_name
    }
}